import {Link} from "react-router-dom";
import * as React from "react";
import {apiClient, DynamicDatagrid, MuiDataGrid, Paper} from "@leap4/frontend";

import {urlService} from "../../../../routing/urlsService";
import {useEffect, useState} from "react";
import {
    IAdServerTag,
} from "@leap4/entities-discrepancy-common";
import { MatchingOrphanAdServerTags} from "../../../../../config/generals";
type GridColDef = MuiDataGrid.GridColDef;
type GridRenderCellParams = MuiDataGrid.GridRenderCellParams;

export const DataPointOrphanTags = ({dataPointId, side, isLoading, setIsLoading, triggerDataRefresh, setChosenRowsIds}) => {
    const [dataPointMatchingTags, setDataPointMatchingTags] = useState<IAdServerTag[]>([])

    useEffect(()=>{
        (async () => {
            setIsLoading(true);

            if(!dataPointId || !side) return setIsLoading(false)

            let matchingTags: IAdServerTag[] = (await apiClient.get(`${MatchingOrphanAdServerTags}/${side}/${dataPointId}`)).data
            setDataPointMatchingTags(matchingTags);
            setIsLoading(false);
        })()
    }, [dataPointId, side, triggerDataRefresh])

    const columns: GridColDef[] = [
        {
            field: 'name',
            headerName: 'Name',
            width: 450,
            renderCell: (params: GridRenderCellParams) => {
                return <Link to={urlService.adServerTag(params.id.toString(), true)}><strong
                >{params.value}</strong></Link>
            }
        },
    ]

    function createRowData(item) {
        return {
            id: item._id,
            name: item.name,
        }
    }

    const rows = !dataPointMatchingTags.length? [] : dataPointMatchingTags.map((tag,) =>
        createRowData(tag)
    );

    return (
        <Paper sx={{margin: "20px 0", borderRadius: "16px", boxShadow: "none"}} elevation={5}>
            <h1 style={{fontFamily:"Quicksand"}}>{Boolean(dataPointId && side)? "Orphan Tags - Select to link" : "Orphan Tags - Select DataPoint & Side first"}</h1>
            <DynamicDatagrid rows={rows}
                             columns={columns}
                             loading={isLoading}
                             refreshFunc={() => {}}
                             loadError={false}
                             pageSize={100}
                             style={{minHeight: `75vh`, width: '100%'}}
                             checkboxSelection
                             disableSelectionOnClick={true}
                             onRowSelectionModelChange={(newChosen)=>setChosenRowsIds(newChosen)}
            />
        </Paper>
    )
}